module.exports = __webpack_public_path__ + "img/game_3.4f613a73.png";